"use strict";

/**
 * Created by sguilly on 23/08/16.
 */
(function () {
  "use strict";

  localStorage.setItem("debug", "");

  var models = angular.module("models");

  if (window.location.href.indexOf("localhost") != -1) {
    var urlNx = "http://localhost:4030/api";
    var urlPdf = "https://htmltopdf.lvr-fleet.fr/v1/generate";
    var urlDepaForm = "http://localhost:4001";
    var urlApp = "http://localhost:4202";
    var urlExportXlsx = "http://localhost:4003";
    var urlAdmin = "http://localhost:3001";
    var urlReadSummary = "http://localhost:4007";
  } else if (window.location.href.indexOf("192.168") != -1) {
    var urlNx = "http://localhost:4030/api";
    var urlPdf = "https://htmltopdf.lvr-fleet.fr/v1/generate";
    var urlDepaForm = "http://localhost:4001";
    var urlApp = "http://localhost:4202";
    var urlExportXlsx = "http://localhost:4003";
    var urlAdmin = "http://localhost:3001";
    var urlReadSummary = "http://localhost:4007";
  } else {
    var urlPdf = "https://htmltopdf.lvr-fleet.fr/v1/generate";
    var urlDepaForm = "https://depa-form.drm-fleet.eu";
    var urlExportXlsx = "https://export-xlsx.drm-fleet.eu";
    var urlReadSummary = "https://read-summary.drm-fleet.eu";

    var _h = window.location.hostname;
    var _env = _h.includes("-test") ? "test" : _h.includes("-beta") ? "beta" : "";
    var _nxPrefix = _env ? "nx-" + _env : "nx";
    var _legacyPrefix = _env ? "app-" + _env : "app";

    if (_h.includes("drm-fleet.io")) {
      var urlNx = "https://" + _nxPrefix + ".drm-fleet.io/api";
    } else if (_h.includes("drm-fleet.eu")) {
      var urlNx = "https://" + _nxPrefix + ".drm-fleet.eu/api";
    } else {
      var urlNx = "https://" + _legacyPrefix + ".lvr-fleet.fr/api";
    }

    if (_env === "test") {
      var urlAdmin = "https://admin-test.drm-fleet.eu";
      var urlApp = "https://app-test.lvr-fleet.fr";
    } else if (_env === "beta") {
      var urlAdmin = "https://admin-beta.drm-fleet.eu";
      var urlApp = "https://app-beta.lvr-fleet.fr";
    } else {
      var urlAdmin = "https://admin.drm-fleet.eu";
      var urlApp = "https://app.lvr-fleet.fr";
    }
  }

  models.constant("SERVER_NX_URL", urlNx);
  models.constant("DEPA_FORM_URL", urlDepaForm);
  models.constant("APP_URL", urlApp);
  models.constant("EXPORT_XLSX_URL", urlExportXlsx);
  models.constant("ADMIN_URL", urlAdmin);
  models.constant("PDF_URL", urlPdf);
  models.constant("READ_SUMMARY_URL", urlReadSummary);

  models.config(["$provide", function ($provide) {
    var log = debug("config:models");

    log("enter");
  }]);
})();